module.exports = __webpack_public_path__ + "static/404-Error-Page-Pups_03-37db6770ce114f60e8f3d058471720b4.png";